import { render } from "./reviews-summary.html?vue&type=template&id=5b047874&ts=true"
import script from "./ReviewsSummary.vue?vue&type=script&lang=ts"
export * from "./ReviewsSummary.vue?vue&type=script&lang=ts"

import "./reviews-summary.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/mnt/data/builder/builder_work/TDxwlwBlLWeBkxmdLwzSnpbrT/widgets_v5/node_modules/.pnpm/vue-loader@16.8.3_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__